import React, { useState } from "react";
import axios from "axios";
import { API_URL } from "./constants/Statics";
import { toast } from "react-toastify";
import { decryptResponse, encryptRequestData } from "./utils/crypto";

const instance = axios.create({
  baseURL: API_URL,
});

let password = "e0m636izi4gnbz9htaxewtr5ogepbwai"

instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

// Request interceptor for handling token authorization
instance.interceptors.request.use(
  async (config) => {
    // First check sessionStorage, then fallback to localStorage for the token
    const JWT_token = sessionStorage.getItem("token") || localStorage.getItem("token");
    if (config.data) {
      try {
        config.data = { payload: (await encryptRequestData(config.data, password)).payload };   
      } catch (e) {
        console.error("Encryption failed:", e);
      }
    }

    if (JWT_token) {
      config.headers.common["Authorization"] = "Bearer " + JWT_token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);



let isUnauthorizedHandled = false;
instance.interceptors.response.use(
  async (response) => {
    try {
      // if (response.config.method.toLowerCase()=="get"){
      //   return response 

      // }
      if (response?.data) {
        const decrypted = await decryptResponse(response.data, password);

        if (decrypted) {
          response.data = JSON.parse(decrypted); // agar string aa raha hai to JSON parse

        }
      }
     
    } catch (e) {
      console.error("Decryption failed vdfdfgfgtgttr:", e);
    }
    return response;
  },


async (error) => {
  if (error.response) {
    const decrypted = await decryptResponse(error.response.data, password);
    

//     let decrypted = null;

// try {
//   decrypted = await decryptResponse(error.response.data, password);

//   if (typeof decrypted === "string") {
//     try {
//       decrypted = JSON.parse(decrypted);
//     } catch (e) {
//       console.error("Invalid error JSON:", decrypted);

//       // force logout
//       localStorage.clear();
//       sessionStorage.clear();
//       window.location.replace("/");
//       return;
//     }
//   }
// } catch (err) {
//   console.error("Decrypt Error:", err);
// }


    const status = error.response.status;

    if ( status === 401 || status === 419) {
      if (!isUnauthorizedHandled) {
        isUnauthorizedHandled = true;
        toast.error(decrypted.message || "Unauthorized access");
        localStorage.clear();
        sessionStorage.clear();
        await new Promise((resolve) => setTimeout(resolve, 2000));
        window.location.replace("/");
      }
    }
    else if (status === 400) {
      let decryptedData

      if (typeof decrypted === "string") {
    try {
      decryptedData = JSON.parse(decrypted);
      console.log(" upload debug message",decryptedData)
      toast.error(decryptedData.message)
     
    }catch (e) {
      console.error("Failed to parse JSON:", e);
    }
  }} else if (status === 422) {
      let decryptedData

      if (typeof decrypted === "string") {
    try {
      decryptedData = JSON.parse(decrypted);
     
    } catch (e) {
      console.error("Failed to parse JSON:", e);
    }
  }
  

      const validationMessage =decryptedData.errors?.[0].msg || "Invalid email or password";
      const validationErrors = decrypted.errors || [];

      // Optionally, aggregate all validation errors into a string
      const errorList = validationErrors
        .map((err) => `${err.param}: ${err.msg}`)
        .join(", ");
      // console.log("object error data",errorList)

      toast.error(`${validationMessage} ${errorList}`, {
        position: "top-right",
      });

      // Return the decrypted error so the caller can handle it further
      return Promise.reject(decrypted);
    } else if (status === 500) {
      toast.error("Server error. Please try again later.");
    }
  } else {
    toast.error("An error occurred. Please try again.");
  }

  return Promise.reject(error);
}

);



export default instance;







// const instance = axios.create({
//   baseURL: API_URL,
// });

// instance.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

// // Request interceptor for handling token authorization
// instance.interceptors.request.use(
//   async (config) => {
//     // First check sessionStorage, then fallback to localStorage for the token
//     const JWT_token = sessionStorage.getItem("token") || localStorage.getItem("token");

//     if (JWT_token) {
//       config.headers.common["Authorization"] = "Bearer " + JWT_token;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// let isUnauthorizedHandled = false; 
 
// instance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     if (error.response) {
//       const status = error.response.status;
 
//       if ((status === 401 || status === 419) && !isUnauthorizedHandled) {
//         isUnauthorizedHandled = true; 
 
//         toast.error(error.response.data.message || "Unauthorized access", {
//           position: "top-right",
//           autoClose: 2000,
//         });
 
//         localStorage.clear();
//         sessionStorage.clear();
 
//         // Delay redirection so the toast can show
//         await new Promise((resolve) => setTimeout(resolve, 2000));
 
//         window.location.replace("/");
 
//         // You don't need to reset the flag since redirect will reload the app
//       } else if (status === 500) {
//         toast.error("Server error. Please try again later.", {
//           position: "top-right",
//         });
//       }
//     } else {
//       toast.error("An error occurred. Please try again.", {
//         position: "top-right",
//       });
//     }
 
//     return Promise.reject(error);
//   }
// );

// export default instance;
